/*
 * Actions
 */
const USER_LOGOUT = 'orgamax/global/USER_LOGOUT'
const USE_MOBILE = 'orgamax/global/USE_MOBILE'
const IS_OFFLINE = 'orgamax/global/IS_OFFLINE'
const IS_WS_OFFLINE = 'orgamax/global/IS_WS_OFFLINE'
const SET_APIVERSION = 'orgamax/global/SET_APIVERSION'
const SET_DELAY_UPDATE_REMINDER = 'orgamax/global/SET_DELAY_UPDATE_REMINDER'
const SET_CELLO_BOOTED = 'orgamax/global/SET_CELLO_BOOTED'
/*
 * Reducer
 */
const initialState = {
  isLoggedOut: false,
  useMobile: false,
  isOffline: false,
  isWSOffline: false,
  apiVersion: ENV.version || '1.0.0',
  delayUpdateReminder: false,
  isCelloBooted: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOGOUT:
      return { ...state, isLoggedOut: true }
    case USE_MOBILE:
      return { ...state, useMobile: true }
    case IS_OFFLINE:
      const { isOffline } = action
      return { ...state, isOffline }
    case IS_WS_OFFLINE:
      const { isWSOffline } = action
      return { ...state, isWSOffline }
    case SET_APIVERSION:
      const { apiVersion } = action
      return { ...state, apiVersion, delayUpdateReminder: false }
    case SET_DELAY_UPDATE_REMINDER:
      const { delayUpdateReminder } = action
      return { ...state, delayUpdateReminder }
    case SET_CELLO_BOOTED:
      const { isCelloBooted } = action
      return { ...state, isCelloBooted }

    default:
      return state
  }
}

/*
 * Action Creators
 */
export const userLoggedOut = () => ({
  type: USER_LOGOUT,
})

export const setUseMobile = () => ({
  type: USE_MOBILE,
})

export const isOffline = isOffline => ({
  type: IS_OFFLINE,
  isOffline,
})

export const isWSOffline = isWSOffline => ({
  type: IS_WS_OFFLINE,
  isWSOffline,
})

export const setApiVersion = apiVersion => ({
  type: SET_APIVERSION,
  apiVersion,
})

export const setDelayUpdateReminder = delayUpdateReminder => ({
  type: SET_DELAY_UPDATE_REMINDER,
  delayUpdateReminder,
})

export const setCelloBooted = isCelloBooted => ({
  type: SET_CELLO_BOOTED,
  isCelloBooted,
})
